<template>  
    <router-view>
    </router-view>
</template>

<style>
    .qweErrorMessageBox .el-message-box__header{
        padding: 0 0 15px 0 !important;
    }

    .qweErrorMessageBox .error-message-box__content{
        padding: 15px 0!important;
    }

    .qweErrorMessageBox .el-message-box__message{
        padding:0px 8px;
    }
</style>

<script>
    import app from "./baseApp"
    export default {
        name:"App",
        mixins:[app]
    }
</script>